module.exports = __webpack_public_path__ + "img/chevron-left.8e05d189.svg";